/**
 * Anbindung an GlitchTip/Sentry -- Frontend-Gegenstueck zu
 * `backend/src/config/sentry.ts`.
 *
 * Dieselbe Entscheidung, derselbe Anbieter (GlitchTip, selbst betrieben,
 * spricht das Sentry-Protokoll), nur mit dem browserfaehigen SDK
 * (`@sentry/react` statt `@sentry/node`) und ohne Mandanten-/
 * Anfragekontext -- der gibt es im Browser nicht auf dieselbe Art.
 *
 * `VITE_SENTRY_DSN` ist eine reine Client-Kennung, kein Geheimnis: ein
 * DSN erlaubt nur das EINLIEFERN von Ereignissen, nie das Lesen
 * bestehender. Sie landet damit unvermeidlich im ausgelieferten Bundle
 * -- das ist bei Sentry/GlitchTip so vorgesehen.
 *
 * Kein Performance-Tracing (`tracesSampleRate: 0`): GlitchTip wird hier
 * ausschliesslich als Fehlerprotokoll betrieben.
 */
import * as Sentry from '@sentry/react';

let clientAktiv = false;

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  // import.meta.env.MODE ist bei Vitest/Jest 'test' -- dort soll nichts
  // versendet werden, aus demselben Grund wie im Backend.
  if (!dsn || import.meta.env.MODE === 'test') return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : undefined,
    tracesSampleRate: 0,
    initialScope: { tags: { runtime: 'frontend' } },
  });
  clientAktiv = true;
}

export function sentryAktiv(): boolean {
  return clientAktiv;
}

export { Sentry };
